module.exports = __webpack_public_path__ + "img/up.4458cce3.svg";